import React from 'react';

type ResolveIconProps = {
  handleEditClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function ResolveIcon({
  handleEditClick,
  className = ''
}: ResolveIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={handleEditClick}
      style={{ color: 'red' }}
    >
      <path
        d="M7.86427 15.7344C7.64161 15.7344 7.43068 15.6357 7.2881 15.4648L3.54103 10.9668C3.27541 10.6484 3.31935 10.1748 3.63673 9.91015C3.95411 9.64453 4.42677 9.68652 4.69337 10.0059L7.84669 13.792L15.2861 4.32323C15.542 3.99706 16.0147 3.94139 16.3389 4.19628C16.665 4.45214 16.7217 4.92382 16.4658 5.24901L8.4541 15.4473C8.31445 15.626 8.10156 15.7314 7.875 15.7344L7.86427 15.7344Z"
        fill="#292929"
      />
    </svg>
  );
}

export default ResolveIcon;
